import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Paragraph,
  Link,
} from "../styles/components/Global/Text";
import animations from "./Animations";

const LinkParagraph = () => {
  const containerRef = useRef(null);
  useEffect(() => {
    animations.parallax(containerRef.current);
  }, []);
  return (
    <TextContainer ref={containerRef} $align="center" $flex>
      <Paragraph $textAlign="center" $width="small" $indent={true}>
        Lotus, the world-renowned brand, stands confidently at the nexus between
        high-performance automobiles and high-fashion. The sleek design and
        meticulous attention to detail of its cars evoke the same dedication and
        care seen in the most lauded haute-couture ateliers. Blasting down
        highways or stomping down runways, the rhythm and purr of the{" "}
        <Link
          href="https://www.lotuscars.com/eletre?utm_source=editorial23&utm_medium=PARTNERWEBSITE&utm_campaign=ELETRE_NA_Influencer_Q3_23&utm_content=HS-editorial"
          target="_blank"
        >
          Lotus Eletre
        </Link>{" "}
        is a must this season for the most voguish of motorheads. In tandem,
        Lotus and Ksawery pay homage to a proud heritage that fuels a future
        where technology drives us forward.
      </Paragraph>
    </TextContainer>
  );
};

export default LinkParagraph;
